import keys from 'lodash/keys';

export const initialValuesConsentFormFields = {
  policyOrClaim: '',
  policyNumber: '',
  claimNumber: '',
  relationship: '',
  qbeBusiness: '',
  firstName: '',
  lastName: '',
  organisation: '',
  personalDetails: false,
  contactDetails: false,
  emailAddress: '',
  phoneNumber: '',
  contactType: null,
  contactPreferedMethod: null,
  postalAddress: '',
  postalAddressObject: null,
  isPostalAddressValid: false,
  isManualAddressEnabled: false,
  streetAddress: '',
  suburb: '',
  country: '',
  state: '',
  postcode: '',
};

export const initialValuesInsuredDetailsFormFields = {
  insuredIndOrBus: null,
  title: '',
  insuredFirstName: '',
  insuredLastName: '',
  dependents: [],
  customerTitle: '',
  customerFirstName: '',
  customerLastName: '',
  contactPersonTitle: '',
  contactFirstName: '',
  contactLastName: '',
  dob: null,
  gender: '',
  cEmailAddress: '',
  addressType: null,

  residentialAddress: '',
  residentialAddressObject: null,
  rStreetAddress: '',
  rSuburb: '',
  rCountry: '',
  rState: '',
  rPostcode: '',
  isResAddressValid: false,
  isManualAddressRes: false,

  cPostalAddress: '',
  cPostalAddressObject: null,
  pStreetAddress: '',
  pSuburb: '',
  pCountry: '',
  pState: '',
  pPostcode: '',
  isPhyAddressValid: false,
  isManualAddressPhy: false,

  haveOneValidNumber: false,
  mPhoneNumber: '',
  hPhoneNumber: '',
  oPhoneNumber: '',
  iContactPreferedMethod: '',

  isVulnerableCustomer: '',
  vulnerabilityReason: '',
  isLanguageInterpreter: '',
  language: '',
  otherLanguage: '',
  customerDesc: '',
  businessName: '',
  isSmallBusiness: '',
  contactType: '',
};

export const initialValuesComplaintDetailsFormFields = {
  complaintDate: null,
  sourceOfComplaint: '',
  acknowledgement: '',
  acknowledgementDate: null,
  productType: '',
  compDescription: '',
  compType: '',
  compCategory: [],
  sensitiveCase: '',
  resolved: '',
  desiredOutcome: '',
  resolvedDate: null,
  outcomeType: '',
  outcomeDesc: '',
  amountInDispute: '',
  amountCompResolved: '',
  isValidDate: false,
  files: [],
};

export const initialHardshipFields = {
  dateOfApplication: null,
  sourceOfApplication: '',
  reason: '',
  assistance: '',
  description: '',
};

export const initialEmploymentFormFields = {
  employmentStatus: '',
  employmentData: [],
};

export const initialIncomeFormFields = {
  incomeStatus: '',
  incomeData: [],
};

export const initialValuesConfirmDetailsFormFields = {
  lodgement: '',
};

export const initialExpenseFormFieldsNumber = {
  rentMortgage: undefined,
  childSupport: undefined,
  otherLoan: undefined,
  motorVehicle: undefined,
  creditCard: undefined,
  livingCosts: undefined,
  utilities: undefined,
  schoolFees: undefined,
  hospitalMedicalCosts: undefined,
  insurance: undefined,
  otherExpense: undefined,
};

export const initialExpenseFormFields = {
  ...initialExpenseFormFieldsNumber,
  declaration: false,
  files: [],
};

export const initialIncidentTypeFormFields = {
  breachType: '',
  rootCause: [],
};

export const initialIncidentDetailsFormFields = {
  occuredDate: null,
  discoveredDate: null,
  breachDescription: '',
  tmdDescription: '',
  gicopArea: '',
  categoryList: [],
  dataPrivacy: [],
  otherDetails: '',
  hasDataPrivacy: false,
};

export const initialBreachOtherDetailsFormFields = {
  productType: '',
  policyNumber: '',
  claimNumber: '',
  customersAffected: '',
  financialLoss: '',
  customerNumber: '',
  estimatedLoss: undefined,
};

export const initialBreachResolutionFormFields = {
  resolved: '', // Yes or No
  resolvedDate: null,
  resolutionDesc: '',
};

export const expenseFormFieldsNumberKeys = keys(initialExpenseFormFieldsNumber);

export const initialFormData = {
  ...initialValuesConfirmDetailsFormFields,
  ...initialValuesConsentFormFields,
  ...initialValuesInsuredDetailsFormFields,
  ...initialValuesComplaintDetailsFormFields,
  ...initialEmploymentFormFields,
  ...initialHardshipFields,
  ...initialIncomeFormFields,
  ...initialExpenseFormFields,
  ...initialIncidentTypeFormFields,
  ...initialIncidentDetailsFormFields,
  ...initialBreachOtherDetailsFormFields,
  ...initialBreachResolutionFormFields,
};
